import React from "react";
import styled from "styled-components";
import { FlexContainer, portalColors } from "src/components";
import { CardSkeleton } from "./CardSkeleton";

const Card = styled.div`
  width: ${p => p.width || "83px"};
  height: ${p => p.height || "47px"};
  border: 1px solid ${portalColors.border};
  border-radius: ${p => p.borderRadius || "7px"};
  box-shadow: 0px 3px 6px #00000029;
  background: ${portalColors.surface};
  overflow: hidden;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: ${p => p.borderRadius || "7px"};
`;

export const ImageVideoCard = ({ src, loading, styles }) => {
    return (
        <FlexContainer>
            <Card width={styles?.width || "83px"} height={styles?.height || "47px"} borderRadius={styles?.borderRadius || "7px"}>
                {!src || loading ? (
                    <CardSkeleton width={styles?.width || "83px"} height={styles?.height || "47px"} borderRadius={styles?.borderRadius || "7px"} />
                ) : (
                    <Image
                        src={src}
                        alt="Category Preview"
                        borderRadius={styles?.borderRadius || "7px"}
                        loading="lazy"
                        decoding="async"
                    />
                )}
            </Card>
        </FlexContainer>
    );
};
